import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteEquipmentModal extends Component {
    handleDelete = async () => {
        const {
            deleteEquipment,
            selectedNode
        } = this.props;

        const parents = selectedNode.parent.split('/');
        const siteId = parents[parents.length - 2];
        const clientId = parents[parents.length - 3];

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await deleteEquipment(selectedNode.id, siteId, clientId);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            title
        } = this.props;

        return (
            <ConfirmActionModal
                errors={errors}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                open={open}
                title={title}
            >
                <p>
                    Warning: Deleting an Equipment will also delete all Sensors tied to this Equipment.
                </p>
                <p>
                    Are you sure you want to delete Equipment: {selectedNode.name}?
                </p>
            </ConfirmActionModal>
        );
    }
}

DeleteEquipmentModal.defaultProps = {
    selectedNode: {}
};

DeleteEquipmentModal.propTypes = {
    close:        func.isRequired,
    open:         bool.isRequired,
    selectedNode: object,
    title:        string.isRequired
};

const mapStateToProps = state => {
    return {
        errors:       state.messages.errors,
        isLoading:    state.ui.isLoading,
        selectedNode: state.architect.selectedNode
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEquipmentModal);
